
import React, { useEffect, useState, useRef, useCallback } from 'react';
import DataGrid, { Selection, RowDragging, Column, Editing, Scrolling, Paging, Toolbar, Item, MasterDetail, Export, RequiredRule } from 'devextreme-react/data-grid';

import Form, { Item as FormItem, GroupItem, ColCountByScreen } from 'devextreme-react/form';
import './EntryForm.scss';
import { getSizeQualifier, useScreenSize } from '../../../utils/media-query';
import { Button, ButtonGroup, Switch } from 'devextreme-react';
import { GENDERS } from '../../../shared/constants';
import { EditCellTimeComponent, TimeBox, TimeBoxBold } from '../../utils/time-box/TimeBox';
import { TimeDropdownBox, TimeDropdownBoxCounter } from '../../utils/time-dropdownbox/TimeDropdownBox';
import { FormPopup } from '../../utils/form-popup/FormPopup';
import { ResultPopup } from '../result-popup/ResultPopup';
import { withLoadPanel } from '../../../utils/withLoadPanel';
import Validator, {
    CustomRule
} from 'devextreme-react/validator';


export const EntryForm = ({ initData, onSave, allowEditing, onDataChanged, athleteStatusChanged }) => {
    const [popupVisible, setPopupVisible] = useState(false);
    const [popupData, setPopupData] = useState(null);
    const currentRow = useRef(null);
    const ResultPopupWithLoadPanel = withLoadPanel(ResultPopup);
    const handlePopupOpen = (rowData) => {

        setPopupData(rowData.bestSwimtimes); // Daten der Zeile an das Popup übergeben
        setPopupVisible(true); // Popup sichtbar machen
    };
    const rowPrepared = (e) => {
        if (e.rowType === "data") {
            if (e.data.entryAllowed === false) {

                e.rowElement.classList.add('disabled-rows');
                // To override alternation color
                e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");

            }
        }
    }
    const cellPrepared = (e) => {
        if (e.rowType === "data" && e.column.dataField === "entrySwimtime") {
            if (e.data.entry == true && (e.data.entrySwimtime == null || e.data.entrySwimtime == 0)) {
                e.cellElement.style.backgroundColor = "#ff9999";
            } else {
                e.cellElement.style.backgroundColor = "";
            }
        }
    }

    const changePopupVisibility = useCallback((isVisble) => {
        setPopupVisible(isVisble);
    }, []);
    const selectAllWithQualification = useCallback(() => {
        const updatedEntries = entryData.entries.map(entry => {
            if (
                entry.qualificationSwimtime != null &&
                entry.entrySwimtimeAdvice != null &&
                entry.qualificationSwimtime > entry.entrySwimtimeAdvice &&
                entry.entryAllowed === true
            ) {
                return {
                    ...entry,
                    entry: true,
                    entrySwimtime: entry.entrySwimtimeAdvice
                };
            }
            return entry;
        });
        const updatedData = { ...entryData, entries: updatedEntries };
        setentryData(updatedData);
        onDataChanged(updatedData);
    }, []);
    const [entryData, setentryData] = useState(initData);
    const { isXSmall, isSmall  } = useScreenSize();
    const gridRef = useRef(null);
    useEffect(() => {
        setentryData(initData);
        gridRef.current?.instance().filter([['entryAllowed', '=', true]]);
    }, [initData]);
    const filterAllowedEvents = useRef(true);
    const onCellClick = useCallback((e) => {
        if (e.column && e.column.dataField === 'bestSwimtimes') {
            currentRow.current = e.data;
            handlePopupOpen(e.data);
        }
    }, [handlePopupOpen]);
    const valueChanged = useCallback((e) => {
        switch (e.itemData.text) {
            case 'alle Strecken anzeigen':
                filterAllowedEvents.current = !filterAllowedEvents.current;
                if (filterAllowedEvents.current) {
                    gridRef.current?.instance().filter([['entryAllowed', '=', true]]);

                } else {
                    gridRef.current?.instance().clearFilter();

                }

                break;
        }
    }, []);

    const resultClick = useCallback((e) => {
        if (e.rowType === 'data') {
            const updatedData = [...entryData.entries];
            const rowIndex = updatedData.findIndex(row => row === currentRow.current);

            if (rowIndex !== -1) {
                updatedData[rowIndex].entrySwimtime = e.data.swimtime; // Setze swimtime
                updatedData[rowIndex].entry = true; // Setze entry auf true
                setentryData({ ...entryData, entries: updatedData });
            }
            updateData();
            setPopupVisible(false);
        }
    }, []);
    const updateData = (e) => {

        onDataChanged(entryData);
    };

    return (
        <div>
            <DataGrid
                className='entries-grid'
                dataSource={entryData.entries}
                remoteOperations={true}
                width={'100%'}
                height={isXSmall  || isSmall ? 'calc(100vh - 120px)' : 'calc(100vh - 280px)'}
                rowAlternationEnabled={true}
                ref={gridRef}
                onEditingStart={function (e) {
                    if (!e.data.entryAllowed) {
                        e.cancel = true;
                    }
                }}
                onCellClick={onCellClick}
                onRowPrepared={rowPrepared}
                onSaved={updateData}
                onCellPrepared={cellPrepared}

            >
                <Editing allowUpdating={allowEditing} allowAdding={false} allowDeleting={false} mode="cell" />
                <Toolbar>
                    <Item location='before' locateInMenu='auto'>
                        <ButtonGroup
                            items={[{ icon: 'alignjustify', text: "alle Strecken anzeigen" }]}
                            selectionMode="multiple"
                            stylingMode="text"

                            onItemClick={valueChanged}
                            cssClass='group-margin'
                        />
                    </Item>
                    <Item location='after' locateInMenu='auto'>
                        <ButtonGroup
                            items={[{ icon: 'selectall', text: "alle mit Qualizeit" }]}
                            selectionMode="multiple"
                            stylingMode="text"
                            onItemClick={selectAllWithQualification}
                            cssClass='group-margin'
                            visible={entryData.qualification && allowEditing}
                        />
                        <ButtonGroup
                            items={[{ icon: 'clearsquare', text: "keine Teilnahme" }, { icon: 'isblank', text: "offen" }]}
                            selectionMode="multiple"
                            stylingMode="text"
                            onItemClick={athleteStatusChanged}
                            cssClass='group-margin'
                            visible={allowEditing}
                        />
                    </Item>
                </Toolbar>
                <Paging enabled={false} />
                <Column dataField="swimstyleName" caption="Schwimmstil" width={120} allowEditing={false} fixed={true} cellRender={(cellData) => (
                    <span style={{ fontWeight: 'bold' }}>{cellData.value}</span>
                )} />
                <Column dataField="entry" caption="Meldung" dataType="boolean" width={80} setCellValue={function (newData, value, currentRowData) {
                    newData.entry = value;
                    if (value) {
                        if (currentRowData.entrySwimtime != '') { newData.entrySwimtime = currentRowData.entrySwimtimeAdvice; }

                    } else {
                        newData.entrySwimtime = null;
                    }

                }}>

                </Column>

                <Column dataField="entrySwimtime" caption="Meldezeit" dataType="number" width={80} cellRender={TimeBoxBold} editCellComponent={EditCellTimeComponent} setCellValue={function (newData, value, currentRowData) {
                    newData.entrySwimtime = value;
                    if (value && value !== '') {
                        newData.entry = true;
                    } else {
                        newData.entry = false;
                    }

                }}>

                </Column>
                <Column dataField="bestSwimtimes" caption="Zeiten" width={150} cellComponent={TimeDropdownBoxCounter} />


                <Column dataField="eventNumber" caption="WK-Nr." width={100} allowEditing={false} />
                <Column dataField="date" caption="Datum" visible={false} sortOrder="asc" groupIndex={0} sortIndex={0} allowEditing={false} groupCellRender={(groupData) => {
                    const formattedDate = new Date(groupData.text).toLocaleDateString('de-DE', { weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric' })
                    return `${formattedDate}`;
                }} />
                <Column dataField="sessionName" caption="Session" width={100} allowEditing={false} groupIndex={1} sortIndex={1} groupCellRender={(groupData) => {
                    return `${groupData.text}`;
                }} />
                <Column dataField="eventRound" caption="Runde" width={120} allowEditing={false} cellRender={(cellData) => {
                    if (!filterAllowedEvents.current) {
                        const gender = GENDERS.find(g => g.id === cellData.data.eventGender)?.text || 'Unbekannt'; // Geschlecht aus GENDERS zuordnen
                        return `${cellData.value} (${gender})`;
                    }
                    else {
                        return `${cellData.value}`;
                    }
                }} />
                <Column dataField="eventGender" caption="Geschlecht" dataType='number' width={100} allowEditing={false} visible={!filterAllowedEvents} lookup={{ dataSource: GENDERS, valueExpr: 'id', displayExpr: 'text' }} />
                <Column dataField="eventOrder" caption="Reihenfolge" visible={false} allowEditing={false} sortOrder='asc' sortIndex={0} />
                <Column dataField="entryAllowed" caption="Eintrag erlaubt" dataType="boolean" allowEditing={false} width={120} visible={false} />
                <Column dataField="qualificationSwimtime" caption="Qualifikationszeit" allowEditing={false} dataType="number" width={150} cellRender={TimeBox} visible={entryData.qualification} />

            </DataGrid>
            <FormPopup title='Wettkampfergebnisse' width={800} visible={popupVisible} setVisible={changePopupVisibility} isSaveVisible={false}>
                <ResultPopupWithLoadPanel hasData={popupData} loading={false} initData={popupData} onResultClick={resultClick} />
            </FormPopup>

        </div>

    );
};
